import PropTypes from 'prop-types';
import { View, Text } from '@react-pdf/renderer';
import styles from './InvoiceStyle';

export default function WorkflowLogTable({ logs }) {
  if (!logs?.length) return null;

  return (<>
    <Text style={[styles.overline, styles.mb8]}>
      Workflow
    </Text>
    <View style={styles.table}>
      <View style={styles.tableBody}>
        {logs.map((log, index) => (
          <View style={styles.voucherTableRow} key={index}>
            <View style={{ width: '10%' }}>
              <Text>{log.step ?? index + 1}</Text>
            </View>

            <View style={{ width: '50%' }}>
              <Text>{log.label}</Text>
            </View>

            <View style={{ width: '40%' }}>
              <Text>
                {log.user || '-'}
                {log.date && log.user ? `  (${log.date})` : ''}
              </Text>
            </View>

          </View>
        ))}
      </View>
    </View></>
  );
}

WorkflowLogTable.propTypes = {
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      step: PropTypes.number,
      label: PropTypes.string.isRequired,
      user: PropTypes.string,
      date: PropTypes.string,
    })
  ),
};
